import type { GetDecisionAssociatedDocuments } from '@livv/models';
import type {
    CreateUser,
    SendOnboardingEmail,
    AiSearchRequest,
    AiSearchStream,
    AiSearchResponse,
    HtmlToPdf,
    GenerateDocumentPdf,
} from '@livv/models/firebaseFunctions';
import type { MuxGetVogelAcademyPlaybackToken } from '@livv/models/firebaseFunctions/mux';
import type {
    ListVogelAcademyWorkshops,
    RegisterVogelAcademyWorkshop,
} from '@livv/models/firebaseFunctions/vogelAcademyWorkshops';
import { httpsCallable } from 'firebase/functions';
import { functions } from '@config/firebase/client';

export const createUser = httpsCallable<CreateUser['input'], CreateUser['output']>(
    functions,
    'createUser',
);

export const userAuth = httpsCallable(functions, 'auth');

export const generateDocumentPdf = httpsCallable<
    GenerateDocumentPdf['input'],
    GenerateDocumentPdf['output']
>(functions, 'generateDocumentPdf');

export const htmlToPdf = httpsCallable<HtmlToPdf['input'], HtmlToPdf['output']>(
    functions,
    'htmlToPdf',
);

export const getDecisionAssociatedDocuments = httpsCallable<
    GetDecisionAssociatedDocuments['input'],
    GetDecisionAssociatedDocuments['output']
>(functions, 'getDecisionAssociatedDocuments');

export const getDecisionAnalyses = httpsCallable(functions, 'getDecisionAnalyses');

export const sendOnboardingEmail = httpsCallable<
    SendOnboardingEmail['input'],
    SendOnboardingEmail['output']
>(functions, 'sendOnboardingEmail');

export const slack = {
    sendNotification: httpsCallable(functions, 'slackSendNotification'),
};

export const searchableRecords = {
    requestKey: httpsCallable(functions, 'searchableRecordsRequestKey'),
};

export const aiSearchBooks = httpsCallable<AiSearchRequest, AiSearchResponse, AiSearchStream>(
    functions,
    'aiSearchBooks',
    { timeout: 540_000 },
);

export const mux = {
    getVogelAcademyPlaybackToken: httpsCallable<
        MuxGetVogelAcademyPlaybackToken['input'],
        MuxGetVogelAcademyPlaybackToken['output']
    >(functions, 'getVogelAcademyPlaybackToken'),
};

export const vogelAcademyWorkshops = {
    list: httpsCallable<ListVogelAcademyWorkshops['input'], ListVogelAcademyWorkshops['output']>(
        functions,
        'listVogelAcademyWorkshops',
    ),
    register: httpsCallable<
        RegisterVogelAcademyWorkshop['input'],
        RegisterVogelAcademyWorkshop['output']
    >(functions, 'registerVogelAcademyWorkshop'),
};
